import { render, staticRenderFns } from "./PzUnnaxIframe.vue?vue&type=template&id=3881d6fd&scoped=true"
import script from "./PzUnnaxIframe.vue?vue&type=script&lang=js"
export * from "./PzUnnaxIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881d6fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3881d6fd')) {
      api.createRecord('3881d6fd', component.options)
    } else {
      api.reload('3881d6fd', component.options)
    }
    module.hot.accept("./PzUnnaxIframe.vue?vue&type=template&id=3881d6fd&scoped=true", function () {
      api.rerender('3881d6fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/OpenBanking/PzUnnaxIframe.vue"
export default component.exports